export default __webpack_public_path__ + "static/media/4c.f6647b89.png";